require("./styles/1_settings/_settings.scss");
require("./styles/2_tools/_tools.scss");
require("./styles/3_generic/_generic.scss");
require("./styles/4_elements/_elements.scss");
require("./styles/5_objects/_objects.scss");
require("./styles/7_utilities/_utilities.scss");

import Vue from "vue";
import { setupInterceptors } from "./_helpers/api-interceptors";
import { store } from "./_store";
import { router, AuthService } from "./_helpers";
import App from "./app/App.vue";
import "./_directives";
import "./_filters";
import "./_mixins";

//IMPORT GLOBAL COMPONENTS
import Paginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import * as VueGoogleMaps from "vue2-google-maps";
import VueCropper from "vue-cropperjs";

import CallCenterAEDModal from "./components/modal.vue";
import CallCenterAEDeditableInput from "./components/AED/editableInput.vue";
import CallCenterAEDeditableTextArea from "./components/AED/editableTextArea.vue";
import CallCenterAEDeditableDate from "./components/AED/editableDate.vue";
import CallCenterAEDeditableDropdown from "./components/AED/editableDropdown.vue";
import CallCenterAEDeditControll from "./components/AED/editControll.vue";
import CallCenterAEDpicture from "./components/picture.vue";

import CallCenterAEDtimeField from "./components/AED/time-field.vue";

Vue.config.productionTip = false;

//REGISTER COMPONENTS
Vue.component("v-paginate", Paginate);
Vue.component("v-datepicker", Datepicker);
Vue.component("v-time", CallCenterAEDtimeField);
Vue.component("v-select", vSelect);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBzQYAoayOgvHm0zXyCBsiT54v_RfqCzv4",
    region: "DK",
    language: "dk",
    libraries: "places" // This is required if you use the Autocomplete plugin
  }
});
Vue.component("v-cropper", VueCropper);

Vue.component("CallCenterAEDModal", CallCenterAEDModal);
Vue.component("CallCenterAEDeditableInput", CallCenterAEDeditableInput);
Vue.component("CallCenterAEDeditableTextArea", CallCenterAEDeditableTextArea);
Vue.component("CallCenterAEDeditableDate", CallCenterAEDeditableDate);
Vue.component("CallCenterAEDeditableDropdown", CallCenterAEDeditableDropdown);
Vue.component("CallCenterAEDeditControll", CallCenterAEDeditControll);
Vue.component("CallCenterAEDpicture", CallCenterAEDpicture);

const waitForApi = setInterval(() => {
  if (Vue.prototype.$api) {
    clearInterval(waitForApi);

    new Vue({
      el: "#app",
      router,
      created() {
        setupInterceptors(Vue.prototype.$api, store);
      },
      store,
      render: h => h(App)
    });
    return;
  }
  Vue.prototype.$api =
    process.env.VUE_APP_APIURL === "window.apiurl"
      ? window.apiurl
      : process.env.VUE_APP_APIURL;
  Vue.prototype.$dawaUrl =
    process.env.VUE_APP_DAWAURL === "window.dawaurl"
      ? window.dawaurl
      : process.env.VUE_APP_DAWAURL;
  let clientId =
    process.env.VUE_APP_AAD_CLIENTID === "config"
      ? window.ad_clientid
      : process.env.VUE_APP_AAD_CLIENTID;
  let authority =
    process.env.VUE_APP_AAD_AUTHORITY === "config"
      ? window.ad_authority
      : process.env.VUE_APP_AAD_AUTHORITY;
  let scopes =
    process.env.VUE_APP_AAD_SCOPES === "config"
      ? window.ad_scopes
      : [process.env.VUE_APP_AAD_SCOPES];

  Vue.prototype.$ad = new AuthService(clientId, authority, scopes);
}, 100);
